import {Directive, Renderer2, ElementRef, OnInit, Input, OnChanges} from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[useLoader]'
})
export class UseLoaderDirective implements OnChanges {
    @Input('useLoader') load: boolean;
    constructor(private elRef: ElementRef,
                private renderer: Renderer2) {
    }

    ngOnChanges() {
        if (this.load) {
            this.renderer.addClass(this.elRef.nativeElement, 'show-loader');
            this.renderer.setStyle(this.elRef.nativeElement, 'position', 'relative');
        }else{
            this.renderer.removeClass(this.elRef.nativeElement, 'show-loader');
        }
    }
}
